/**
 * SUBSCRIPTION STATUS ENUM
 * 
 * Estados diagnósticos da assinatura.
 * Puramente indicativo - sem automação.
 * 
 * @version 1.0.0
 */

export const SUBSCRIPTION_STATUS = {
  /**
   * Assinatura válida
   * Dias restantes > 7
   * Usuário pode usar a plataforma normalmente
   */
  VALID: 'valid',

  /**
   * Assinatura expirando em breve
   * Dias restantes entre 0 e 7 (inclusive)
   * Usuário deve renovar em breve
   */
  EXPIRING_SOON: 'expiring_soon',

  /**
   * Assinatura expirada
   * Dias restantes < 0
   * Usuário precisa renovar imediatamente
   */
  EXPIRED: 'expired',

  /**
   * Status desconhecido
   * Sem subscriptionExpiresAt
   * Conta não aprovada ou dados incompletos
   */
  UNKNOWN: 'unknown',
} as const;

/**
 * Type helper para values do enum
 */
export type SubscriptionStatusType = typeof SUBSCRIPTION_STATUS[keyof typeof SUBSCRIPTION_STATUS];
